(() => {
  const init = () => document.querySelectorAll('[data-restored-paths]:not([data-paths-ready])').forEach(root => {
    root.dataset.pathsReady = 'true';
    const cards = [...root.querySelectorAll('.mbv__pick-card')];
    const claim = root.querySelector('[data-pick-claim]');
    const label = root.querySelector('[data-pick-claim-label]');
    const status = root.querySelector('[data-path-status]');
    let selected = cards.find(card => card.hasAttribute('data-pick-default')) || cards[0];
    let busy = false;
    const sync = () => {
      const add = selected.querySelector('[data-offer-add]');
      claim.disabled = add.disabled;
      label.textContent = busy ? add.textContent : add.disabled ? 'Currently unavailable' : 'Claim my spot';
      status.textContent = selected.querySelector('[data-offer-status]').textContent;
      if (busy && !add.disabled) busy = false;
      const amount = selected.querySelector('[data-offer-price]').textContent.trim();
      document.dispatchEvent(new CustomEvent('pick-your-path:changed',{detail:{
        ready:!add.disabled,mode:selected.dataset.pickMode,
        name:selected.querySelector('.mbv__pick-name').textContent.trim(),
        subtitle:selected.querySelector('.mbv__pick-desc').textContent.trim(),
        todayDisplay:selected.dataset.pickMode==='archive'?amount:'',
        monthlyDisplay:selected.dataset.pickMode==='solo'?amount:''
      }}));
    };
    const select = card => {
      if (busy) return;
      selected = card;
      cards.forEach(c => {
        c.classList.toggle('mbv__pick-card--selected', c === card);
        c.setAttribute('aria-checked', String(c === card));
        c.tabIndex = c === card ? 0 : -1;
      });
      sync();
    };
    cards.forEach((card,index) => {
      card.addEventListener('click', event => {
        if (event.target.closest('[data-offer-add]')) return;
        select(card);
      });
      card.addEventListener('keydown', event => {
        if (['Enter',' '].includes(event.key)) {event.preventDefault();select(card);}
        if (['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(event.key)) {
          event.preventDefault();
          const next = cards[(index + (['ArrowDown','ArrowRight'].includes(event.key) ? 1 : cards.length - 1)) % cards.length];
          select(next);next.focus();
        }
      });
      new MutationObserver(sync).observe(card,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    });
    claim.addEventListener('click', () => {
      if (busy || claim.disabled) return;
      busy = true;
      selected.querySelector('[data-offer-add]').click();
      sync();
    });
    select(selected);
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
